const aboutData = {
  title: 'About',
  description: `I started taking headshots for friends and classmates while attending KD Studio Actors Conservatory in 2007. While there I was able to learn what makes for a great photo. Whether it's for the next audition, or the annual family photo, I can take care of it. Contact me today, and we can set up a session at your convenience. I look forward to meeting you!`,
} 

export default aboutData
